<div class="ui basic segment nav aligned">
    <app-header title="{{ 'settings.invoices.header' | appTranslate }}" [back]="true"></app-header>

    <app-table [table]="table">
        <div class="empty">
            <img style="max-width: 30%" src="/assets/illustrations/clipboard-stars.png" />
            <h2 class="ui centered header">{{ 'settings.invoices.noInvoicesMessage' | appTranslate }}</h2>
        </div>
    </app-table>
</div>
